import {combineReducers} from 'redux'

import {currentDateReducer} from '../../../ordoro/CurrentDateListener.js'
import productKits from './productKits.js'
import returnOrders from './returnOrders.js'

export default combineReducers({
  currentDate: currentDateReducer,
  productKits,
  returnOrders,
})
